module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "新增系统权限",
      "center": true,
      "visible": _vm.addVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "add-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限名称",
      "prop": "permissionName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-权限名称"
    },
    model: {
      value: (_vm.submitData.permissionName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "permissionName", $$v)
      },
      expression: "submitData.permissionName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限路由",
      "prop": "permissionPath"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-权限路由"
    },
    model: {
      value: (_vm.submitData.permissionPath),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "permissionPath", $$v)
      },
      expression: "submitData.permissionPath"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限编码",
      "prop": "permissionCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-权限编码"
    },
    model: {
      value: (_vm.submitData.permissionCode),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "permissionCode", $$v)
      },
      expression: "submitData.permissionCode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限类型",
      "prop": "permissionType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true,
      "placeholder": "请选择权限类型"
    },
    on: {
      "change": _vm.handlePermissionTypeChange
    },
    model: {
      value: (_vm.submitData.permissionType),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "permissionType", $$v)
      },
      expression: "submitData.permissionType"
    }
  }, _vm._l((_vm.permissionTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序",
      "prop": "sortIndex"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-排序"
    },
    model: {
      value: (_vm.submitData.sortIndex),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "sortIndex", $$v)
      },
      expression: "submitData.sortIndex"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "permissionRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-备注"
    },
    model: {
      value: (_vm.submitData.permissionRemark),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "permissionRemark", $$v)
      },
      expression: "submitData.permissionRemark"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "上级权限",
      "prop": "parentId"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.parentPermVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.submitData.parentPermissionName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "图标",
      "prop": "permissionIcon"
    }
  }, [(_vm.$isNull(_vm.submitData.permissionIcon)) ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.permIconVisible = true
      }
    }
  }, [_vm._v("选择图标")]) : _c('i', {
    class: _vm.submitData.permissionIcon,
    staticStyle: {
      "font-size": "30px",
      "color": "#589df8"
    },
    on: {
      "click": function($event) {
        _vm.permIconVisible = true
      }
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择图标",
      "visible": _vm.permIconVisible,
      "append-to-body": true,
      "width": "80%",
      "before-close": _vm.handleMenuIconCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.permIconVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "menu-icon-view"
  }, _vm._l((_vm.iconList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "icon-item-view",
      on: {
        "click": function($event) {
          return _vm.handleMenuIconSelect(item)
        }
      }
    }, [_c('i', {
      class: item,
      staticStyle: {
        "margin": "3px 3px",
        "font-size": "20px",
        "color": "#589df8"
      }
    })])
  }), 0)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.parentPermVisible,
      "width": "30%",
      "append-to-body": "",
      "before-close": _vm.handleParentPermSelect
    },
    on: {
      "update:visible": function($event) {
        _vm.parentPermVisible = $event
      }
    }
  }, [_c('el-tree', {
    ref: "permissionTree",
    attrs: {
      "data": _vm.permissionTreeNode,
      "show-checkbox": "",
      "node-key": "authPermissionId",
      "default-checked-keys": [],
      "highlight-current": "",
      "check-strictly": true,
      "props": _vm.permissionTreeNodeProps
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleParentPermSelect
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleParentPermSelect
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a3b00cbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3b00cbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/platform/auth-permission/ItemAdd.vue
// module id = 1318
// module chunks = 1